import Model from "../Model";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import Loading from "../Loading";
import { useFormik } from "formik";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";

const validationSchema = Yup.object().shape({
  mobile: Yup.string().required("Mobile number is required"),
  name: Yup.string().required("Name is required"),
  city: Yup.string().required("City is required"),
  email: Yup.string()
    .matches(
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
      "Enter a valid email address",
    )
    .nullable()
    .notRequired()
    .transform((value) => (value === "" ? null : value)),
});

const AddUserModel = ({ isRegisterLoading, addUserMutate, setAddUser }) => {
  const initialValues = {
    name: "",
    mobile: "",
    city: "",
    email: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      addUserMutate(values);
    },
  });

  return (
    <Model width="w-11/12 max-w-md" setOpenModel={setAddUser}>
      <FormWrapper>
        <Title>Add User</Title>
        <form onSubmit={formik.handleSubmit}>
          <FormWrapper>
            <InputGroup>
              <Label htmlFor="name">Name</Label>
              <Input
                name="name"
                type="text"
                placeholder="Enter name"
                value={formik.values.name}
                onChange={(e) => {
                  // Remove numbers from input
                  const value = e.target.value.replace(/[0-9]/g, "");
                  formik.setFieldValue("name", value);
                }}
                onBlur={formik.handleBlur}
              />
              {formik.touched.name && formik.errors.name && (
                <ErrorText>{formik.errors.name}</ErrorText>
              )}
            </InputGroup>

            <InputGroup>
              <Label htmlFor="mobile">Mobile</Label>
              <Input
                name="mobile"
                type="mobile"
                placeholder="Enter mobile number"
                value={formik.values.mobile}
                onChange={formik.handleChange}
                maxLength={10}
                pattern="[0-9]{10}"
                // onBlur={formik.handleBlur}
              />
              {formik.touched.mobile && formik.errors.mobile && (
                <ErrorText>{formik.errors.mobile}</ErrorText>
              )}
            </InputGroup>

            <CombineInputGroup>
              <InputGroup>
              <Label htmlFor="email">Email</Label>
              <Input
                name="email"
                type="email"
                placeholder="Enter email"
                value={formik.values.email}
                onChange={formik.handleChange}
                maxLength={10}
                pattern="[0-9]{10}"
                // onBlur={formik.handleBlur}
              />
              {formik.touched.email && formik.errors.email && (
                <ErrorText>{formik.errors.email}</ErrorText>
              )}
            </InputGroup>

            <InputGroup>
              <Label htmlFor="city">City</Label>
              <Input
                name="city"
                type="city"
                placeholder="Enter city"
                value={formik.values.city}
                onChange={formik.handleChange}
                maxLength={10}
                pattern="[0-9]{10}"
                // onBlur={formik.handleBlur}
              />
              {formik.touched.city && formik.errors.city && (
                <ErrorText>{formik.errors.city}</ErrorText>
              )}
            </InputGroup>
            </CombineInputGroup>
          </FormWrapper>

          <BtnWrapper>
            <SubmitBtn type="submit">
              {isRegisterLoading ? (
                <Loading height={16} width={16} noPadding={true} />
              ) : (
                "Add User"
              )}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </FormWrapper>
    </Model>
  );
};

const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const ErrorText = tw.div`text-red-500 text-sm`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const CombineInputGroup = tw.div`flex space-x-7`;
const FormWrapper = tw.div`px-1  space-y-3 `;
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;

export default AddUserModel;
